import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { t } from '../../translations/i18n';
import { IWorkspaceEnrichedMesh } from '../../models/IMeshes';
import { getRouteByPath, ROUTES } from '../../app/routes';
import WorkspaceMeshesManager from '../../managers/WorkspaceMeshesManager';
import { store } from '../../store/store';
import MikeButton from '../../shared-components/mike-button';
import { useNavigate } from 'react-router-dom';

type ConfirmDeleteDialogProps = {
  projectId: string;
  workspaceId: string;
  mesh: IWorkspaceEnrichedMesh;
  open: boolean;
  onClose: (confirmed: boolean) => void;
};

/**
 * Shows a confimation dialog for deleting a mesh and deletes the mesh if user confirms
 * @param props
 *
 * Todo hevo confirm dialogs for all layer types (meshes, geometry and variables) are avery similar. We could maybe like make something more reusable.
 */
export const MmgConfirmDeleteMeshDialog = (props: ConfirmDeleteDialogProps) => {
  const navigate = useNavigate();
  const { open, onClose, mesh, projectId, workspaceId } = props;

  if (!mesh) {
    return;
  }

  const meshId = mesh.id;

  const handleClose = () => {
    onClose(false);
  };

  const handleOk = () => {
    onMeshDelete();
    closeDialog(true);
  };

  const handleCancel = () => {
    closeDialog(false);
  };

  const closeDialog = (confirmed: boolean) => {
    onClose(confirmed);
  };

  const onMeshDelete = () => {
    return WorkspaceMeshesManager.deleteMeshes(workspaceId, [meshId])
      .then(() => {
        const toast = {
          text: t('DELETED', 1, {
            thing: t('MESH'),
          }),
        };
        store.dispatch({ type: 'toast/ADD/SUCCESS', toast });

        store.dispatch({
          type: 'workspace/meshes/DELETE_SUCCESS',
          workspaceMeshes: [meshId],
        });
        navigate(getRouteByPath(ROUTES.workspacePanel.path, { workspaceId, projectId }, ROUTES.workspace.path));  
      })
      .catch((error) => {
        const toast = {
          text: t('FAILED_TO', 1, { action: t('DELETE') }),
          operationId: error.operationId,
        };
        store.dispatch({ type: 'toast/ADD/ERROR', toast });
        throw error;
      });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      id="confirm-delete-mesh"
      aria-labelledby="delete-mesh-dialog-title"
      aria-describedby="delete-mesh-dialog-description"
    >
      <DialogTitle id="delete-mesh-dialog-title">
        {t('MESH_CONFIRM_DELETE_TITLE')}
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="delete-mesh-dialog-description">
          {t('MESH_CONFIRM_DELETE_TEXT', 1, {
            name: mesh.name,
          })}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <MikeButton onClick={handleCancel} variant="outlined" color="secondary">
          {t('CANCEL')}
        </MikeButton>

        <MikeButton onClick={handleOk} variant="contained" color="secondary" autoFocus>
          {t('DELETE')}
        </MikeButton>
      </DialogActions>
    </Dialog>
  );
};
